import React from 'react';
import { ActionsColumn, Input, Spinner } from '@tlx/atlas';
import { SelectAllState } from '@Page/SalaryRun/stateReducer.ts';
import { AUTH_LEVEL_READ_ONLY, useTskContext } from '@Hooks/useTskContext.ts';

interface TableHeaderCheckboxProps {
    selectAllState: SelectAllState;
    isCheckedAll: boolean;
    onCheckAll: () => void;
    indeterminateCheckboxRef: React.Ref<HTMLInputElement>;
}

const SelectAllColumns: React.FC<TableHeaderCheckboxProps> = ({
    selectAllState,
    isCheckedAll,
    onCheckAll,
    indeterminateCheckboxRef,
}) => {
    const { authLevelEmployeeOrWage } = useTskContext();
    return (
        <ActionsColumn>
            {selectAllState === SelectAllState.SPINNER ? (
                <div className="tsk-spinner">
                    <Spinner size="small" />
                </div>
            ) : (
                <Input
                    ref={indeterminateCheckboxRef}
                    id={'check-all'}
                    type={'checkbox'}
                    data-testid="checkbox-all"
                    checked={isCheckedAll}
                    onChange={onCheckAll}
                    disabled={
                        selectAllState === SelectAllState.DISABLED || authLevelEmployeeOrWage <= AUTH_LEVEL_READ_ONLY
                    }
                />
            )}
        </ActionsColumn>
    );
};

export default SelectAllColumns;
